// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"8a2cd821","279":"7cadf42e"}[chunkId] + ".chunk.css";
};